import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { axiosInstance } from "../utils/config";
import Loader from "../components/Loader/Loader";
import Login from "../pages/Login";

const userContext = createContext();

const UserProvider = ({ children }) => {
  const navigate = useNavigate();
  const [loadProfile, setLoadProfile] = useState(false);

  const [auth, setAuth] = useState({
    user: null,
    loading: false,
    error: null,
  });

  // 🔹 New: Login Modal State
  const [loginModal, setLoginModal] = useState(false);

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const fetchProfile = async () => {
    setAuth((prevState) => ({
      ...prevState,
      loading: true,
      error: null,
    }));
    
    await axiosInstance
      .get("/me", { withCredentials: true })
      .then((data) => {
        setAuth({
          user: data?.data?.user,
          loading: false,
          error: null,
        });
      })
      .catch((error) => {
        setAuth((prevState) => ({
          ...prevState,
          loading: false,
          error:
            error?.response?.data?.message === "Not logged in"
              ? null
              : error?.response?.data?.message,
        }));
      });
  };

  // Function to refetch the profile data
  const refetchProfile = async () => {
    await fetchProfile();
  };

  useEffect(() => {
    if (loadProfile) {
      refetchProfile();
    }
  }, [loadProfile]);

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleLogout = async () => {
    setAuth((prev) => ({
      ...prev,
      loading: true,
    }));
    await axiosInstance
      .get("/logout", { withCredentials: true })
      .then((data) => {
        if (data?.data?.success) {
          document.cookie = "saajFarmToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          navigate("/");
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => {
        setAuth({
          user: null,
          loading: false,
          error: null,
        });
      });
  };

  const isAuthenticated = () => {
    const token = getCookie('saajFarmToken');
    return !!token && !!auth.user;
  };

  useEffect(() => {
    if (auth.error) {
      toast.error(auth.error);
      setAuth((prevState) => ({
        ...prevState,
        error: null,
      }));
    }
  }, [auth.error]);

  return (
    <userContext.Provider
      value={{
        auth,
        setAuth,
        loading: auth?.loading,
        refetchProfile,
        logout: handleLogout,
        loadProfile,
        setLoadProfile,
        loginModal,
        setLoginModal,
        isAuthenticated,
        getCookie,
      }}
    >
      {auth?.loading ? <Loader /> : children}

      {loginModal && <Login show={loginModal} setShow={setLoginModal} />}
    </userContext.Provider>
  );
};

const useAuth = () => useContext(userContext);

export { useAuth, UserProvider };